import apiClient from '../api/apiClient'
import type {
  CreateEducationRequest,
  EducationResponse,
  EducationListResponse,
  UserEducation,
} from '../types/api'

export class EducationService {
  async createEducation(
    userId: string | number,
    educationData: CreateEducationRequest
  ): Promise<EducationResponse> {
    const encodedUserId = encodeURIComponent(String(userId));
    const { data } = await apiClient.post<EducationResponse>(
      `/admin/users/${encodedUserId}/education`,
      educationData,
    );
    return data;
  }

  async getEducations(userId: string | number): Promise<EducationListResponse> {
    const encodedUserId = encodeURIComponent(String(userId));
    const { data } = await apiClient.get<EducationListResponse>(
      `/admin/users/${encodedUserId}/education`,
    );
    return data;
  }

  async getEducation(userId: string | number, educationId: number): Promise<{ education: UserEducation }> {
    const encodedUserId = encodeURIComponent(String(userId));
    const { data } = await apiClient.get<{ education: UserEducation }>(
      `/admin/users/${encodedUserId}/education/${educationId}`,
    );
    return data;
  }

  async updateEducation(
    userId: string | number,
    educationId: number,
    educationData: CreateEducationRequest
  ): Promise<EducationResponse> {
    const encodedUserId = encodeURIComponent(String(userId));
    const { data } = await apiClient.put<EducationResponse>(
      `/admin/users/${encodedUserId}/education/${educationId}`,
      educationData,
    );
    return data;
  }

  async deleteEducation(userId: string | number, educationId: number): Promise<EducationResponse> {
    const encodedUserId = encodeURIComponent(String(userId));
    const { data } = await apiClient.delete<EducationResponse>(
      `/admin/users/${encodedUserId}/education/${educationId}`,
    );
    return data;
  }
}

export const educationService = new EducationService();
